import * as React from 'react';

import { UitkQueuedImage } from 'uitk-react-images';

import { FavoriteButton } from 'components/common/shortlist/favorite-button';
import { RenderImageProps } from './title';
import * as uniqid from 'uniqid';

interface TitleImageProps {
  src?: string;

  renderImg: RenderImageProps;
  serverRender: boolean;
  loaded?: boolean;
}

export const serverRenderImageFallbackcb = (fallback: string, style: any) => {
  const hasBackgroundSrc = style && style.backgroundImage;
  const fallbackStyle = `url(${fallback})`;

  if (!hasBackgroundSrc && fallback) {
    return { backgroundImage: fallbackStyle };
  } else if (hasBackgroundSrc && fallback && style.backgroundImage !== fallbackStyle) {
    return { backgroundImage: `${style.backgroundImage}, ${fallbackStyle}` };
  }

  return style;
};

export const TitleImage: React.FunctionComponent<TitleImageProps> = ({ src, renderImg, serverRender, loaded }) => {
  const {
    fallbackImageSrc,
    name,
    propertyListingBadgeModel,
    ratio,
    referralObject,
    shortlistModel,
    favButtonText,
    queuedImageFallbackcb,
  } = renderImg;

  const primary = propertyListingBadgeModel && propertyListingBadgeModel.primary;
  const id = primary && primary.text === 'Sponsored' ? 'favorite-sponsored' : 'favorite';
  const meta = shortlistModel && shortlistModel.meta;
  const hotelId = meta && meta.hotelId;

  const imageSrc = typeof src === 'undefined' ? '' : src || fallbackImageSrc;
  const queuedImageFallbackCallback = imageSrc
    ? (queuedImage: Record<string, unknown>) => queuedImageFallbackcb(fallbackImageSrc, queuedImage)
    : null;
  const serverRenderImageFallbackStylecb = imageSrc
    ? (style: Record<string, unknown>) => serverRenderImageFallbackcb(fallbackImageSrc, style)
    : null;

  return (
    <UitkQueuedImage
      src={imageSrc}
      alt={name}
      className={`image-loader${serverRender ? '' : ' image-loader--lazy'}`}
      useBackgroundImage={true}
      groupId="HSR"
      queuedImageFallbackCallback={queuedImageFallbackCallback}
      ratio={ratio}
      serverRenderCallback={serverRenderImageFallbackStylecb}
      serverRender={serverRender}
      loaded={loaded}
    >
      {hotelId && (
        <FavoriteButton
          key={hotelId}
          shortlistModel={shortlistModel}
          category="hotel"
          labelSave={favButtonText.labelSave}
          labelRemove={favButtonText.labelRemove}
          onSaveMessage={favButtonText.onSaveMessage}
          id={uniqid(`${id}-${hotelId}`)}
          referralObject={referralObject}
        />
      )}
    </UitkQueuedImage>
  );
};
TitleImage.displayName = 'TitleImage';
